import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchTournament } from '../actions';
import Octicon, {Check, Pencil} from '@githubprimer/octicons-react';
import ParticipantListDownloadPanel from './ParticipantListDownloadPanel';
import AdminNavigationBar from './AdminNavigationBar';
import TournamentInfo from './TournamentInfo';

class ParticipantsList extends Component {
  constructor() {
    super();
    this.state = { participants: [] };
    this.deleteTournament = this.deleteTournament.bind(this);
    this.deleteEntry = this.deleteEntry.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const self = this;
    fetch(`/api/tournaments/${this.tournamentId()}/participants`, { credentials: 'same-origin' }).then(response => {
      response.json().then(participantList => {
        self.setState({ participants: participantList });
      });
    });
    if (this.tournament() === undefined) {
      dispatch(fetchTournament(this.tournamentId()));
    }
  }

  tournamentId() {
    return parseInt(this.props.match.params.id, 10);
  }

  tournament() {
    return this.props.tournaments.find(tournament => tournament.id === this.tournamentId());
  }

  selectEntry(index) {
    return (evt) => {
      this.setState({selectedIndex: index});
    };
  }

  deleteTournament() {
    fetch(`/api/tournaments/${this.tournament().id}`, { method: 'DELETE', credentials: 'same-origin' }).then(response => {
      if (response.status === 200) {
        location.href = '#/admin';
      }
    });
  }

  deleteEntry() {
    const deletedEntryIndex = this.state.selectedIndex;
    const deletedEntryId = this.state.participants[deletedEntryIndex].id;
    fetch(
      `/api/tournaments/${this.tournament().id}/participants/${deletedEntryId}`,
      { method: 'DELETE', credentials: 'same-origin' }
    ).then(response => {
      if (response.status === 200) {
        const updatedParticipants = this.state.participants.slice();
        updatedParticipants.splice(deletedEntryIndex, 1);
        this.setState({participants: updatedParticipants, selectedIndex: undefined});
      }
    });
  }

  paymentSum() {
    if (this.tournament().pricing) {
      return (
        <tr>
          <th colSpan="9">
            Suma wpłat: {
              this.state.participants
                .filter(p => p.paymentStatus === 'COMPLETED')
                .map(p => p.totalPrice)
                .reduce((a, b) => a + b, 0)
            } zł
          </th>
        </tr>
      );
    } else {
      return '';
    }
  }

  render() {
    const tournament = this.tournament();

    if (tournament !== undefined) {
      return (
        <div>
          <AdminNavigationBar />
          <div className="container">
            <div className="float-right">
              <Link to={'/admin/tournaments/' + tournament.id + '/edit'}><button className="btn btn-secondary ml-1 mr-1">Edytuj</button></Link>
              <button className="btn btn-danger ml-1 mr-1" data-toggle="modal" data-target="#deleteTournamentModal">Usuń turniej</button>
            </div>
            <TournamentInfo tournament={tournament} />
            <h3>Zarejestrowani zawodnicy</h3>
            <table className="table table-striped">
              <thead>
                {this.paymentSum()}
                <tr>
                  <th colSpan="9">
                    <ParticipantListDownloadPanel tournament={tournament} />
                  </th>
                </tr>
                <tr>
                  <th>#</th>
                  { tournament.type === 'TEAMS' ? <th>Nazwa</th> : ''}
                  <th>ID PZBS</th>
                  <th>Imię i nazwisko</th>
                  <th>WK</th>
                  <th>Okręg</th>
                  <th>Info</th>
                  <th>Zniżka</th>
                  <th>Składka</th>
                  { tournament.pricing ? <th>Opłata</th> : '' }
                  <th><Octicon icon={Pencil} /> Akcje</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.participants.map((participant, index) =>
                    <tr>
                      <td>{index + 1}<br /></td>
                      { tournament.type === 'TEAMS' ? <td>{participant.name}</td> : '' }
                      <td>{ participant.players.map(player => <span>{player.id}<br /></span>) }</td>
                      <td>{ participant.players.map(player => <span>{player.name} {player.surname}<br /></span>) }</td>
                      <td>{ participant.players.map(player => <span>{player.rank}<br /></span>) }</td>
                      <td>{ participant.players.map(player => <span>{player.location}<br /></span>) }</td>
                      <td>{ participant.players.map(player => <span>{player.infoString}<br /></span>) }</td>
                      <td>{ participant.players.map(player => <span>{player.hasDiscount ? <Octicon icon={Check}/> : ''}<br /></span>) }</td>
                      <td>{ participant.players.map(player => <span>{player.hasPaidFee ? <Octicon icon={Check}/> : ''}<br /></span>) }</td>
                      { tournament.pricing ? <td>{ participant.paymentStatus === 'COMPLETED' ? <div><div><span>{participant.totalPrice} zł</span></div><div>{participant.email}</div></div> : '' }</td> : '' }
                      <td>
                        <button className="btn btn-sm btn-danger" data-toggle="modal" onClick={this.selectEntry(index)} data-target="#deleteEntryModal">Usuń</button>
                      </td>
                  </tr>
                  )
                }
              </tbody>
            </table>
          </div>
          <div className="modal fade" id="deleteTournamentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Usuń turniej</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  Czy na pewno chcesz <b>nieodwracalnie</b> usunąć turniej &quot;{tournament.name}&quot;?
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-dismiss="modal">Nie</button>
                  <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.deleteTournament}>Tak</button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="deleteEntryModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Usuń rejestrację</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <span>Czy na pewno chcesz usunąć tę rejestrację?</span>
                  <div className="mt-2 mb-2">
                    {
                      this.state.selectedIndex !== undefined ?
                        this.state.participants[this.state.selectedIndex].players.map(player => <div><b>{player.name} {player.surname}</b></div>) : ''
                    }
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-dismiss="modal">Nie</button>
                  <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.deleteEntry}>Tak</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (<div></div>);
    }
  }
}

function mapStateToProps(state) {
  return { tournaments: state.tournaments };
}

export default connect(mapStateToProps)(ParticipantsList);



// WEBPACK FOOTER //
// ./components/ParticipantsList.js